var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoEdlenDev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 391.1 153.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #458045;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #4e4e4e;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.3,90.1h48.8v15.2H0V.3h64v15.2H15.3v29.6h47.6v15.3H15.3v29.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.7.3c34.4,0,51.7,26.3,51.7,52.6s-17.3,52.4-51.7,52.4h-37.7V.3h37.7ZM108.7,90.1c24.3,0,36.7-18.6,36.7-37.2s-12.3-37.4-36.6-37.4h-22.5v74.6h22.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.4,90.1h49.4v15.2h-64.6V.3h15.2v89.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.6,90.1h48.8v15.2h-64.1V.3h64v15.2h-48.7v29.6h47.6v15.3h-47.6v29.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313.2,105.3V0l11.7.2,51.2,74V.2h15v105.1h-12l-50.8-73.4v73.4h-15.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.5,145.5v-25.5h10c3.6,0,6.7,1.1,9.2,3.3s3.8,5.4,3.8,9.4-.4,4-1.2,5.7-1.9,3-3.2,4c-1.3,1-2.8,1.8-4.3,2.3-1.5.5-3.1.8-4.7.8H5.5ZM10,141.4h3.4c3.1,0,5.6-.7,7.5-2.1,1.9-1.4,2.9-3.6,2.9-6.5s-.9-5.1-2.6-6.5c-1.7-1.4-4-2.1-7-2.1h-4.1v17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.7,138.4h-13.2c.1,1.2.6,2.2,1.5,3,.9.7,1.9,1.1,3.1,1.1,1.8,0,3.4-.8,4.6-2.3l3.1,2.3c-1.9,2.3-4.3,3.5-7.3,3.5s-4.9-.8-6.7-2.5c-1.8-1.7-2.7-3.9-2.7-6.5s.9-4.8,2.7-6.5c1.8-1.7,4-2.5,6.7-2.5s4.4.8,5.9,2.5c1.5,1.7,2.2,4,2.2,6.9v1.2ZM51.5,135.2h8.9c0-1.3-.4-2.3-1.2-3-.8-.7-1.8-1.1-3.2-1.1s-2.3.4-3,1.1c-.8.7-1.3,1.7-1.4,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.2,145.5l-7.1-17.3h4.7l4.6,12.1h0l4.6-12.1h4.4l-6.8,17.3h-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.4,138.4h-13.2c.1,1.2.6,2.2,1.5,3,.9.7,1.9,1.1,3.1,1.1,1.8,0,3.4-.8,4.6-2.3l3.1,2.3c-1.9,2.3-4.3,3.5-7.3,3.5s-4.9-.8-6.7-2.5c-1.8-1.7-2.7-3.9-2.7-6.5s.9-4.8,2.7-6.5c1.8-1.7,4-2.5,6.7-2.5s4.4.8,5.9,2.5c1.5,1.7,2.2,4,2.2,6.9v1.2ZM122.3,135.2h8.9c0-1.3-.4-2.3-1.2-3-.8-.7-1.8-1.1-3.2-1.1s-2.3.4-3,1.1c-.8.7-1.3,1.7-1.4,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.2,145.5v-27.2h4.3v27.2h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M182.1,143.4c-1.8-1.7-2.7-3.9-2.7-6.5s.9-4.8,2.7-6.5c1.8-1.7,4-2.5,6.7-2.5s4.9.8,6.7,2.5c1.8,1.7,2.7,3.9,2.7,6.5s-.9,4.8-2.7,6.5c-1.8,1.7-4,2.5-6.7,2.5s-4.9-.8-6.7-2.5ZM185.1,133.2c-.9,1-1.4,2.2-1.4,3.7s.5,2.6,1.4,3.7c.9,1,2.2,1.5,3.7,1.5s2.8-.5,3.7-1.5c.9-1,1.4-2.2,1.4-3.7s-.5-2.6-1.4-3.7c-.9-1-2.2-1.5-3.7-1.5s-2.8.5-3.7,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M217.9,153.8v-25.5h4.1v2.6h0c1.2-2,3.2-3,5.9-3s4.7.9,6.2,2.6c1.5,1.7,2.3,3.9,2.3,6.5s-.8,4.8-2.3,6.5c-1.6,1.7-3.6,2.6-6,2.6s-4.5-.9-5.9-2.6h-.1v10.4h-4.3ZM230.8,140.6c.9-1,1.4-2.2,1.4-3.7s-.5-2.6-1.4-3.7c-.9-1-2.2-1.5-3.7-1.5s-2.8.5-3.7,1.5c-.9,1-1.4,2.2-1.4,3.7s.5,2.6,1.4,3.7c.9,1,2.2,1.5,3.7,1.5s2.8-.5,3.7-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.1,145.5v-17.3h4.1v2.7h0c1-2.1,2.7-3.1,5.3-3.1s4.5,1.1,5.4,3.2c1.2-2.1,3.1-3.2,5.7-3.2s3.8.7,4.8,2c1,1.3,1.5,3.1,1.5,5.4v10.3h-4.3v-9.8c0-2.7-1.1-4-3.2-4s-2.2.4-2.8,1.3c-.6.9-.9,1.9-.9,3.2v9.4h-4.3v-10.3c0-2.4-1-3.5-3-3.5s-2.3.4-3,1.2c-.6.8-1,1.9-1,3.2v9.4h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M319.9,138.4h-13.2c.1,1.2.6,2.2,1.5,3s1.9,1.1,3.1,1.1c1.8,0,3.4-.8,4.6-2.3l3.1,2.3c-1.9,2.3-4.3,3.5-7.3,3.5s-4.9-.8-6.7-2.5c-1.8-1.7-2.7-3.9-2.7-6.5s.9-4.8,2.7-6.5c1.8-1.7,4-2.5,6.7-2.5s4.4.8,5.9,2.5c1.5,1.7,2.2,4,2.2,6.9v1.2ZM306.7,135.2h8.9c0-1.3-.4-2.3-1.2-3-.8-.7-1.8-1.1-3.2-1.1s-2.3.4-3,1.1c-.8.7-1.3,1.7-1.4,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.6,145.5v-17.3h4.1v2.8h0c1-2.1,2.7-3.2,5.3-3.2s3.8.6,4.8,1.9c1,1.3,1.5,2.9,1.5,4.9v10.9h-4.3v-8.7c0-.6,0-1.2,0-1.6s-.2-1-.4-1.6c-.2-.6-.5-1-1-1.4-.5-.3-1-.5-1.8-.5-1.3,0-2.3.4-3,1.2-.6.8-1,1.9-1,3.2v9.4h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M377.5,131.9h-3.6v-3.7h3.6v-5h4.3v5h4.8v3.7h-4.8v7.6c0,.9.2,1.6.5,2.1.3.5,1,.7,1.9.7s1.9-.2,2.3-.5v3.6c-.8.4-1.9.6-3.4.6-2.2,0-3.7-.5-4.5-1.4s-1.2-2.5-1.2-4.7v-7.9Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEdlenDev);
export default __webpack_public_path__ + "static/media/logo-edlen-DEV.7a31978df3baa7b3e0f2b91fe406148b.svg";
export { ForwardRef as ReactComponent };